// src/Dashboard/pages/user/PrepaPhysique/components/PrepaPhysiqueAdherentSelector.jsx

import React from "react";
import { FaUserCircle } from "react-icons/fa";

function getAdherentName(adherent) {
  const prenom = String(adherent?.prenom || "").trim();
  const nom = String(adherent?.nom || "").trim().toUpperCase();

  return `${prenom} ${nom}`.trim() || "Adhérent";
}

export default function PrepaPhysiqueAdherentSelector({
  adherents = [],
  selectedAdherentId,
  setSelectedAdherentId,
  exercisesBySelectedCount = 0,
  loading,
}) {
  if (loading || adherents.length <= 1) {
    return null;
  }

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Profil adhérent
            </p>

            <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
              Choisir le profil à consulter
            </h2>

            <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              Votre compte peut être rattaché à plusieurs adhérents.
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm dark:border-slate-700 dark:bg-slate-800/60">
            <span className="text-slate-500 dark:text-slate-400">
              Exercices :
            </span>{" "}
            <span className="font-bold text-slate-900 dark:text-white">
              {exercisesBySelectedCount}
            </span>
          </div>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {adherents.map((adherent) => {
            const selected =
              String(selectedAdherentId) === String(adherent.id);

            return (
              <button
                key={adherent.id}
                type="button"
                onClick={() => setSelectedAdherentId(String(adherent.id))}
                className={`flex items-center gap-3 rounded-2xl border px-4 py-3 text-left transition ${
                  selected
                    ? "border-indigo-300 bg-indigo-50 ring-2 ring-indigo-100 dark:border-indigo-500/30 dark:bg-indigo-500/10 dark:ring-indigo-500/20"
                    : "border-slate-200 bg-white hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:hover:bg-slate-900"
                }`}
              >
                <span
                  className={`grid h-11 w-11 shrink-0 place-items-center rounded-2xl ${
                    selected
                      ? "bg-indigo-600 text-white"
                      : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-300"
                  }`}
                >
                  <FaUserCircle />
                </span>

                <div className="min-w-0">
                  <p className="truncate text-sm font-bold text-slate-900 dark:text-white">
                    {getAdherentName(adherent)}
                  </p>

                  <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
                    Saison {adherent?.saison_active || "—"}
                  </p>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}